import { keyframes } from '@emotion/react'

export const FadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`
export const FadeOut = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`
export const ScaleUp = keyframes`
  from { transform: scale(1) }
  to { transform: scale(1.1) }
`
export const ScaleDown = keyframes`
  from { transform: scale(1.1) }
  to { transform: scale(1) }
`
// translate 보다 translate3D 가 모든 브라우져에서 더 나은 성능을 보여주기 때문에 translate3D 를 사용하도록 한다
export const ScrollUp = keyframes`
  from { transform: translate3d(0, 100%, 0); opacity: 0 }
  to { transform: translate3d(0, 0, 0); opacity: 1 }
`
export const ScrollDown = keyframes`
  from { transform: translate3d(0, 0, 0); opacity: 1 }
  to { transform: translate3d(0, 100%, 0); opacity: 0 }
`
export const ScrollLeft = keyframes`
  from { transform: translate3d(100%, 0, 0) }
  to { transform: translate3d(0, 0, 0) }
`
export const ScrollRight = keyframes`
  from { transform: translate3d(0, 0, 0) }
  to { transform: translate3d(100%, 0, 0) }
`

export const Ripple = keyframes`
  to { transform: scale(4); opacity: 0; }
`
export const Growth = keyframes`
  from { transform: scale(0) }
  to { transform: scale(1) }
`
export const Shrinks = keyframes`
  from {
    transform: scale(1)
  }
  to {
    transform: scale(0)
  }
`
export const Spin = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(360deg)
  }
`
export const Blink = keyframes`
  0% {
    opacity: .25;
  }
  35%, 70% {
    opacity: 1;
  }
  100% {
    opacity: .25;
  }
`
